import { Component, Input } from '@angular/core';
import { IonContent, IonGrid } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { ModalService } from '@services/modal.service';
import { ConsentIframeComponent } from '../consent-iframe/consent-iframe.component';
import { IconComponent } from '@shared/svg-icon/svg-icon.component';

@Component({
  selector: 'app-consent-dialog',
  styleUrl: './consent-dialog.component.scss',
  templateUrl: './consent-dialog.component.html',
  imports: [IonContent, TranslateModule, IonGrid, ConsentIframeComponent, IconComponent],
})
export class ConsentDialogComponent {
  @Input() key!: string;

  signedDocuments?: string[];
  closeTimeout?: ReturnType<typeof setTimeout>;

  constructor(private readonly modalService: ModalService) {}

  signDocuments(documentIds: string[]): void {
    this.signedDocuments = documentIds;
    this.closeTimeout = setTimeout(() => {
      this.modalService.dismissLatest(this.signedDocuments);
    }, 3000);
  }

  onClose(): void {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
    this.modalService.dismissLatest(this.signedDocuments);
  }
}
